import { Accordion, Col, Row } from "react-bootstrap";
import type { AccountHoldingResponse } from "../../../api/src/accounts/accounts.service";
import type { RebalanceType } from "../../../api/src/rebalances/rebalances.service";
import type { ModelAssignmentStrategy } from "../components/ModelSourceBadge";
import RebalanceAccountInsights, {
  type RebalanceAccountWithMetrics,
} from "./RebalanceAccountInsights";
import TradesEditor from "./TradesEditor";

export type { RebalanceAccountWithMetrics } from "./RebalanceAccountInsights";

const RebalanceAccountInfo = ({
  rebalanceAccount,
  accountIndex,
  holdings,
  rebalanceType,
  householdModelId,
  modelAssignmentStrategy = "fallback",
  editable = false,
}: {
  rebalanceAccount: RebalanceAccountWithMetrics;
  accountIndex: number;
  holdings: AccountHoldingResponse[];
  rebalanceType: RebalanceType;
  householdModelId?: number | null;
  modelAssignmentStrategy?: ModelAssignmentStrategy | null;
  editable: boolean;
}) => {
  return (
    <>
      <RebalanceAccountInsights
        rebalanceAccount={rebalanceAccount}
        rebalanceType={rebalanceType}
        householdModelId={householdModelId}
        modelAssignmentStrategy={modelAssignmentStrategy}
      />
      <Row className="mt-4">
        <Col className="mb-4">
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Trades</Accordion.Header>
              <Accordion.Body style={{ padding: "0.25rem" }}>
                <TradesEditor
                  accountIndex={accountIndex}
                  holdings={holdings}
                  rebalanceAccount={rebalanceAccount}
                  disabled={!editable}
                />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
    </>
  );
};

export default RebalanceAccountInfo;
